import { useMutation } from '@tanstack/react-query';
import type { PaymentSchemeEditDto } from '../../models/payment-schemes/payment-scheme-edit.dto';
import apiRequest from '../../services/apiWrapper';
import { PAYMENT_SCHEMES_URL } from '../../utils/constants/urlConstants';

async function updatePaymentSchemeById(
  id: string | null,
  updateSchemeData: PaymentSchemeEditDto
) {
  return apiRequest.put(`${PAYMENT_SCHEMES_URL}/${id}`, updateSchemeData);
}

export function useUpdatePaymentSchemeById(id: string | null) {
  return useMutation({
    mutationFn: (updateSchemeData: PaymentSchemeEditDto) =>
      updatePaymentSchemeById(id, updateSchemeData),
  });
}
